const throttleWithTrailing = (fn, throttleMs = 200) => {
  let timeoutId = null;
  let lastArgs = null;
  return (...args) => {
    lastArgs = args;
    if (timeoutId === null) {
      timeoutId = setTimeout(() => {
        if (lastArgs) {
          fn(...lastArgs);
          lastArgs = null;
        }
        timeoutId = null;
      }, throttleMs);
    }
  };
};
export default throttleWithTrailing;